import ScrollBar from "react-perfect-scrollbar";
import { Card, CardBody, Col } from "reactstrap";
import { H4, Image, LI, P, UL } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Href, ScrollableContents } from "../../../../Constant";
import { SCROLLABLE_CONTENT } from "../../../../Data/Bonus Ui/Scrollable";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { DynamicScrollableContent } from "./DynamicScrollableContent";

const ScrollableContent = () => {
  return (
    <Col xl="4"  md="6">
      <Card>
        <CommonCardHeader title={ScrollableContents} span={SCROLLABLE_CONTENT} />
        <CardBody>
          <ScrollBar className="scroll-demo scroll-b-none" style={{ width: "100%", height: "300px" }}>
            <UL className="main-lists-content">
              <LI tag="a" className="list-group-item-action active list-hover-primary" href={Href}>
                <div className="list-wrapper gap-0">
                  <Image className="list-img" src={dynamicImage("user/9.jpg")} alt="profile" />
                  <div className="list-content">
                    <H4>Molly Boake</H4>
                    <P>MollyBoake@rhyta.com</P><small>5 days ago</small></div>
                </div>
              </LI>
              <DynamicScrollableContent />
            </UL>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ScrollableContent;
